import { ITimeSlotApiResponse, TimeSlot } from './timeslot';

export class AvailabilityResponse {
  availableSlots: TimeSlot[];
  cache: boolean;
  cacheTimestamp: Date;

  constructor(json: IAvailabilityApiResponse) {
    this.availableSlots = json.available_slots.map((x) => new TimeSlot(x));
    this.cache = json.cache;
    this.cacheTimestamp = json.cache_timestamp;
  }
}

export interface IAvailabilityApiResponse {
  available_slots: ITimeSlotApiResponse[];
  cache: boolean;
  cache_timestamp: Date;
}
